<div class="logo">
    <div class="icon">
        <img ngSrc="assets/icons/hw-logo.png"
             width="34"
             height="28"
             alt="Hopewell Logo"/>
    </div>

    <div class="name">Hopewell</div>
</div>
